module.exports = __webpack_public_path__ + "static/media/converter1.0f4d8570.jpg";